import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { useIsAtScenarioLimit } from "in_queue/hooks/useIsAtScenarioLimit";
import { useIsScenarioCreationEnabled } from "in_queue/hooks/useIsScenarioCreationEnabled";
import { ScenarioStage } from "in_queue/types/scenarioType";
import React, { PropsWithChildren } from "react";
import { ADMIN_TYPE } from "types/roleType";
import { AdminOnlyTooltip } from "./AdminOnlyTooltip";
import { CreationDisabledForStageTooltip } from "./CreationDisabledForStageTooltip";
import { ScenarioLimitTooltip } from "./ScenarioLimitTooltip";
export const AllScenarioTooltips: React.FC<
    PropsWithChildren<{
        stage: ScenarioStage;
    }>
> = ({ children, stage }) => {
    const { role } = useUserDataContext();
    const isAdmin = role === ADMIN_TYPE;
    const isAtScenarioLimit = useIsAtScenarioLimit();
    const isScenarioCreationEnabled = useIsScenarioCreationEnabled({
        stage
    });

    return (
        <AdminOnlyTooltip>
            <ScenarioLimitTooltip
                isAtScenarioLimit={isAdmin && isAtScenarioLimit}
            >
                <CreationDisabledForStageTooltip
                    creationDisabled={
                        isAdmin &&
                        !isAtScenarioLimit &&
                        !isScenarioCreationEnabled
                    }
                    stage={stage}
                >
                    {children}
                </CreationDisabledForStageTooltip>
            </ScenarioLimitTooltip>
        </AdminOnlyTooltip>
    );
};
